import {
  defineStore
} from 'pinia';
import axios from 'axios';
import {
  showToast
} from "vant";

export const useAuthStore = defineStore('auth', {
  state: () => {
    return {
      user: {},
      jsBridgePackage: {},
    };
  },
  getters: {
    nameLength: (state) => state.name.length,
  },
  actions: {
    loginByWx(code) {
      return new Promise((resolve) => {
        axios
          .get("https://zsrbactivity.zsnews.cn/api/common/wechatoath", {
            params: {
              code
            }
          })
          .then((res) => {
            console.log("res==>", res);
            if (res.status === 200) {
              const data = res.data
              if (data.code == 1) {
                data.wxInfo = JSON.stringify(data.data)
                data.nickName = data.data.nickName
                sessionStorage.setItem("wxInfo", JSON.stringify(data.data))
                sessionStorage.setItem("nickName", data.data.nickname)
                resolve()
              } else {
                showToast(data.msg)
              }
            }
          })
          .catch((err) => {
            console.log(err);
            showToast("网络错误，请重试")
          })
      })
    },
    getZsplusJsBrigde() {
      return new Promise((resolve) => {
        axios
          .get("https://zsrbactivity.zsnews.cn/api/common/zsrbjsbrigeconfig")
          .then((res) => {
            if (res.status === 200) {
              const data = res.data;
              if (data.code === 1) {
                // updateJsBridgePackage(data.data);
                resolve(data.data);
              } else {
                showToast(data.msg);
              }
            } else {
              showToast("网络错误，请重试1");
            }
          })
          .catch((err) => {
            alert(err)
            showToast("网络错误，请重试2");
          });
      });
    },
    loginByZsplus(info) {
      return new Promise((resolve) => {
        axios
          .post("https://zsrbactivity.zsnews.cn/api/common/zsplusauth", {
            sessionToken: info.sessionToken,
            head: info.head,
            nickName: info.nickName,
            phone: info.phone,
            gender: info.gender,
          })
          .then((res) => {
            if (res.status === 200) {
              const data = res.data;
              if (data.code == 1) {
                // 存储中山+授权用户信息
                sessionStorage.setItem("zsplusInfo", JSON.stringify(data.data));
                const {
                  aplus_queue
                } = window;
                aplus_queue.push({
                  action: "aplus.setMetaInfo",
                  arguments: ["_user_id", data.data.user_id],
                });
                // info.nickName info.head info.sessionToken info.gender info.phone
                resolve();
              } else if (data.code == 2) {
                //sessionToken过期,需要配合iOS端做统一处理
                showToast(data.msg);
              } else {
                showToast(data.msg);
              }
            } else {
              showToast("网络错误，请重试3");
            }
          });
      });
    },
    // updateJsBridgePackage(jsBridgePackage) {
    //   this.jsBridgePackage = jsBridgePackage;
    // },
  },
});